export default __webpack_public_path__ + "static/media/featSport.953dcb55.png";